/* eslint-disable ember/no-computed-properties-in-native-classes, ember/no-runloop */
import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import { later } from '@ember/runloop';
import { tablePrintCss } from 'linced-app/utils/table';
import {
  cleanExcelSheetName,
  cleanFileName,
  uniqueSheetName,
} from '@linc-technologies/linced-common/utils/file-names';
import moment from 'moment';
import { sort } from '@ember/object/computed';
import { action } from '@ember/object';
import { naturalSort } from '@linc-technologies/linced-common/utils/sorting';
import { mapBy } from '@linc-technologies/linced-common/utils/arrays';

export default class AllController extends Controller {
  @service
  excel;

  title = 'All Class Lists';
  @tracked
  sortProp = 'lastName';
  @tracked
  sortDir = 'asc';

  @sort('model.homerooms', naturalSort('name'))
  sortedHomerooms;

  @action
  onChangeSort({ sortProp, sortDir }) {
    this.sortProp = sortProp;
    this.sortDir = sortDir;
  }

  @action
  downloadFullXlsx() {
    let sheets = [];
    let sheetNames = [];

    this.sortedHomerooms.forEach((homeroom) => {
      let sheetName = uniqueSheetName(
        cleanExcelSheetName(homeroom.name),
        sheetNames,
      );
      sheetNames.push(sheetName);

      sheets.push({
        name: sheetName,
        data: this.getExportData(homeroom),
      });
    });

    let fileName = `${this.title} ${moment().format('YYYY-MM-DD')}.xlsx`;

    this.excel.export(sheets, {
      multiSheet: true,
      fileName: cleanFileName(fileName),
    });
  }

  @action
  print() {
    let printer = window.open(
      'about:blank',
      '_blank',
      'menubar=yes,location=no,resizable=yes,scrollbars=yes,status=no,height=700,width=1024',
    );
    let classLists = document.querySelectorAll('.class-list');
    let content = tablePrintCss;

    content += `<style>.table-tools button { display: none; }</style>`;

    classLists.forEach((classList, index) => {
      if (index !== 0) {
        content += `<div style="page-break-before: always"></div>`;
      }

      content += classList.outerHTML;
    });

    printer.document.body.innerHTML = content;

    later(
      this,
      (printer) => {
        printer.print();
        printer.close();
      },
      printer,
      500,
    );
  }

  getExportData(homeroom) {
    let data = [];
    let staff = mapBy(homeroom.currentStaff, 'fullName');
    staff.push(`${homeroom.currentLearners.length} students`);

    // Class info
    data.push([`${homeroom.name}`], [`${staff.join(' - ')}`]);

    // Column headers
    data.push(['Name', 'Year Level', 'Notes']);

    // Data
    homeroom.currentLearners.forEach((learner) => {
      data.push([learner.fullName, learner.person.currentYearLevel, '']);
    });

    return data;
  }
}
